<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-end.mb-3
      .col-12
        h2.m-0
          i {{$route.name}}
    section
      .d-flex.row.flex-row.mt-4
        .col-12
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h3.mb-3.ad_text-primary
                .card.pt-4.px-3.ad_border1-secondaryLight.rounded-xl(v-for="(cp, i) in list")
                  .row.d-flex.mb-3.align-items-end
                    .d-flex.col
                      span.text-muted {{ cp.users[0].name }}                   
                    //- .d-flex.col
                    //-   span.text-muted KPI Personal: {{ cp.personal_kpi }}%
                    .d-flex.col-auto
                      span.h4.mr-3.mb-0
                        | {{ moment(cp.date).utc().format("DD/MM/YYYY") }}
                      router-link.btn.btn-secondary.px-3(:to="{name: 'Seguimiento Diario Ejecutar', params: { id:cp._id } }")
                        | Ejecutar
                  .col-12.py-2.rounded-lg.ad_bg-gray.mb-3
                    .d-flex.row
                      .col-12
                        table.w-100.table-rounded-body
                          thead
                            tr
                              th(colspan="2") Objetivos
                              th
                          tbody
                            tr(v-for="obj in cp.objectives" :key="obj.id")
                              td.py-1
                                div(v-if="obj.travel")
                                  i.icon-letters.icon-letters__viaje.mr-1 V
                                  | {{obj.travel.name}}
                              td.py-1
                                div(v-if="obj.product")
                                  i.icon-letters.icon-letters__producto.mr-1 P
                                  | {{obj.product.name}}
                              td.py-1
                                div(v-if="obj.segment")
                                  i.icon-letters.icon-letters__segmento.mr-1 S
                                  | {{obj.segment.name}}
                              td.py-1
                                div
                                  i.icon-letters.icon-letters__negocio.mr-1 N
                                  | {{obj.business_type.name}}
                              td.py-1
                                div
                                  i.icon-letters.icon-letters__kpi.mr-1 A
                                  | {{obj.kpi ? obj.kpi.name : ''}}
                              td.py-1.text-right
              //- h3.mb-3
              //-   i Pendientes
              //- .row
              //-   .col-12
              //-     table.w-100.table-rounded-body.table-rounded-body_gray
              //-       thead
              //-         tr
              //-           th.font-weight-bold Colaborador
              //-           th.font-weight-bold Objetivo
              //-           th.font-weight-bold.text-center KPI Personal
              //-           th.font-weight-bold.text-center Fecha
              //-           th.font-weight-bold.text-right Ejecutar
              //-       tbody
              //-         tr(v-for="(cp, n) in list")
              //-           td
              //-             div
              //-               | {{ cp.users[0].name}}
              //-           td
              //-             div
              //-               small
              //-                 a(:id="'provisionhome' + n")
              //-                   i.icon-letters.icon-letters__viaje.mr-1 V
              //-                   i.icon-letters.icon-letters__producto.mr-1 P
              //-                   i.icon-letters.icon-letters__segmento.mr-1 S
              //-                 b-tooltip(:target="'provisionhome' + n" , placement='top')
              //-                   | {{ `${cp.objectives[0].travel.name} + ${cp.objectives[0].product.name} + ${cp.objectives[0].segment.name}`}}
              //-               small
              //-                 a.mx-2(:id="'kpihome' + n")
              //-                   i.icon-letters.icon-letters__negocio.mr-1 N
              //-                 b-tooltip(:target="'kpihome' + n" , placement='top')
              //-                   | {{ cp.objectives[0].business_type.name }}
              //-               i.icon-letters.icon-letters__kpi.mr-1 A
              //-               | {{ cp.objectives[0].kpi.name }}
              //-           td
              //-             div.justify-content-center
              //-               | {{ cp.personal_kpi }}%
              //-           td
              //-             div.justify-content-center
              //-               | {{ moment(cp.date).utc().format("MM/DD/YYYY") }}
              //-           td
              //-             div.justify-content-end
              //-               router-link.btn.btn-secondary.px-3(:to="{name: 'Seguimiento Diario Ejecutar', params: { id:cp._id } }")
              //-                 | Ejecutar
    section
      .d-flex.row.flex-row.mt-4
        .col-12
          .card.p-0.ad_border1-primaryLight.rounded-xl
            .card-body
              h4.mb-3.ad_text-primary
                i Historial
              .row.flex-row.d-none
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-10
                  .row
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      .ad_select
                        select(v-model='selected')
                          option(:value="null" disabled) Campo de selección
                          option(:value="dummy.value" v-for="dummy in dummys") {{dummy.value}}
                    .form-group.col-4
                      input.form-control(type="text" placeholder="Campo de texto")
                .col-2
                  button.btn.btn__medium.btn-secondary(@click.prevent='loadListHistory')
                    | Aplicar

              .row.mt-3(v-show="historial")
                .col-12
                  b-table.w-100.text-center.table-simple(
                    show-empty
                    stacked="md"
                    :items='listHistory',
                    :fields="fields",
                    :sort-compare= "dateSorter",
                    :current-page="0",
                    :sort-by="sortBy",
                    :sort-desc="sortDesc",
                    :per-page="perPage")
                    template(slot='view', slot-scope='row') 
                      router-link(:to="{path:'/seguimiento-diario/'+row.item.id+'/detail'}" v-bind:tooltip="Detail" append)
                        i.icono.icono-ver.ad_text-primary.align-top

                  b-pagination(
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage",
                  @input="selectedPage()",
                  class="my-0")


    v-navigation-drawer(v-model='drawer', app='', temporary='', right='', width='500')
      header.ad_bg-primary.pt-5.pb-2.px-4
        h3.text-white.mt-4
          i Comentarios
      section.py-4.px-2.overflowy-auto
        .col.d-flex.flex-nowrap
          label
            p.icon-letters.icon-letters__viaje.mr-1 Via
            | Viaje
          label.ml-3
            p.icon-letters.icon-letters__kpi.mr-1 Kpi
            | KPI de Negocio 1
        .row.align-items-end
          .col
            .col-12
              h4 KPI Adherencia
          .col-auto.pr-5
            p.d-inline-block.mb-0.mr-3.ad_text-grayMedio
              sup Registro
              span.ad_text-grayDark 60%
            p.d-inline-block.mb-0.ad_text-grayMedio
              sup Meta
              span 90%
      .flex-row
        .col-12.mt-4
          .form-group.mt-4
            textarea.form-control(placeholder='Agregar comentario' rows='3')
          .form-group.justify-content-between
            button.btn.btn-grayLight-border.py-2.pl-2.pr-3.font-1em(@click="drawer = false")
              i.far.fa-times-circle.fa-1x.mr-1.align-bottom
              | Cancelar
            button.btn.btn-secondary.py-2.pr-2.pl-3.font-1em(@click="moveobjetivo = true; drawer = false;")
              | Agregar comentario
              i.fas.fa-plus-circle.fa-1x.ml-1.align-bottom
          
          hr.my-4
          
          h3.ad_text-grayMedio.mb-3
            i Anteriores
          .row.mb-3(v-for='n in 4')
            .col-4.pr-0
              p.font-weight-bold.m-0 Francisco G
              small.d-block 10-05-2018
              small.d-block 20:30 hrs.
            .col-8.pl-0
              .dialog-box
                p Lorem ipsum dolor sit amet, consectetur adipisicing elit. Culpa ullam facilis provident quia delectus, aut ad odio, non debitis accusamus. Hic quis sit repudiandae, veritatis perferendis magni distinctio minima tempore.
                

</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment-timezone';

export default {
  name: 'SeguimientoDiarioHome',
  components: {},
  data() {
    return {
      sortBy: "executionDate",
      sortDesc: true,
      historial: true,
      selected: null,
      drawer: null,
      list: null,
      listHistory: null,
      dummys: [
        { value: "Demo 1", label: "Demo 1" },
        { value: "Demo 2", label: "Demo 2" },
        { value: "Demo 3", label: "Demo 3" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      fields: [
        { key: 'executionDate', label: 'Ejecucion', sortable: true, sortDirection: 'desc', class: 'text-center'},
        { key: 'collaborator', label: 'Colaborador', sortable: true, class: 'text-left'},
        { key: 'mandated', label: 'Encargado', sortable: true, class: 'text-left'},
        { key: 'objectivesCount', label: 'Obj.', sortable: true, class: 'text-center'},
        { key: 'personalCommitmentsCount', label: 'Comp. Personales' , sortable: true, class: 'text-center'},
        { key: 'leaderCommitmentsCount', label: 'Comp. Líder' , sortable: true, class: 'text-center'},
        { key: 'opportunitiesProblemsCount', label: 'Prob/Oport' , sortable: true, class: 'text-center'},
        { key: 'view', label: 'Ver' , class: 'text-center'}
      ],
    };
  },
  methods: {
    moment,
    ...mapActions('tracing', ['getByCreator', 'getByCreatorHistory']),
    ...mapActions('plan', ['planByWeek']),
    dateSorter(a, b, key) {
      if (key !== "executionDate") {
        return null; // or false
      }
      let aDate = moment(a[key], "DD/MM/YYYY");
      let bDate = moment(b[key], "DD/MM/YYYY");
      if (aDate.isValid && bDate.isValid) {
        if (aDate < bDate) {
          return -1;
        } else if (aDate > bDate) {
          return 1;
        } else {
          return 0;
        }
      }
      return null;
    },
    listing() {
      const vm = this
      const loading = vm.$toast.loading('Cargando SD...')
      const id = vm.$store.state.auth.user.id
      vm.planByWeek({date: new Date(moment()), id}).then(plan => {
        vm.plan = plan
        plan === null ? loading.hide() : null
        const data = {
          plan: plan._id,
          type: 'SD'
        }
        vm.getByCreator(data).then(response => {
          vm.list = response
          loading.hide()
        }, (error) => {
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        }).catch(err => {
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'No existe plan para esta semana',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    },
    loadListHistory() {
      const vm = this;
      const loading = vm.$toast.loading("Cargando Histórico SDs...");
      const data = {
        userId: vm.$store.state.auth.user.id,
        type: 'SD',
        pagination: {page: vm.currentPage, perPage: vm.perPage}
      }
      vm.getByCreatorHistory(data).then((response) => {
        vm.listHistory = response.docs;
        vm.totalRows = response.total;
        vm.currentPage = response.page
        loading.hide()
      }, (error) => {
        loading.hide()
        vm.$notify({
          type: "danger",
          title: "Notificación",
          content: error.payload.message,
          closeable: true,
          duration: 5000
        });
      })
    },
    selectedPage() {
      const vm = this
      vm.loadListHistory()
    }
  },
  watch: {
    moveobjetivo: function() {
      let moveobjetivo = this.moveobjetivo;
      if (this.moveobjetivo === true) {
        this.$emit("can-continue", { value: true });
        this.$emit("completed-step", { value: true });
      } else {
        this.$emit("can-continue", { value: false });
      }
    },
    drawer: function() {
      this.$parent.overlay = !this.$parent.overlay;
      this.$emit("clase", this.$parent.overlay);
      const el = document.querySelector(".overlay");

      if (this.$parent.overlay) {
        el.classList.add("open");
      } else {
        el.classList.remove("open");
      }
    }
  },
  mounted() {
    this.$emit('can-continue', { value: true });
    const vm = this
    vm.listing()
    vm.loadListHistory()
}
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/seguimiento-diario-home.vue